import { render, staticRenderFns } from "./ComponentInvesting.vue?vue&type=template&id=07b2efef"
import script from "./ComponentInvesting.vue?vue&type=script&lang=js"
export * from "./ComponentInvesting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports